<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.body_composition')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/body_composition.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.body_weight_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="bodyWeightData">{{ bodyWeightData.value }} {{bodyWeightData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="bodyWeightData"> <span  style="font-weight: bold">{{ bodyWeightData.previousValue }} {{ bodyWeightData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/body_composition.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.body_fat_percentage_short') }} %</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="bodyFatData">{{ bodyFatData.value }} {{bodyFatData.units}}</span>
              <span v-else> N/A </span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="bodyFatData"><span style="font-weight: bold">{{ bodyFatData.previousValue }} {{ bodyFatData.units }} </span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}</span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/body_composition.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.body_water_percentage_short') }} %</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="bodyWaterData">{{ bodyWaterData.value }} {{bodyWaterData.units}}</span>
              <span v-else> N/A </span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="bodyWaterData"><span style="font-weight: bold">{{ bodyWaterData.previousValue }} {{ bodyWaterData.units }} </span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}</span>
            </span>
          </div>
        </td>
      </tr>
    </table>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/body_composition.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.body_mass_index_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="bodyMassIndexData">{{ bodyMassIndexData.value }} {{bodyMassIndexData.units}}</span>
              <span v-else> N/A </span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="bodyMassIndexData"><span style="font-weight: bold">{{ bodyMassIndexData.previousValue }} {{ bodyMassIndexData.units }} </span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}</span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/body_composition.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.body_muscle_mass_short') }} %</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="bodyMuscleMassData">{{ bodyMuscleMassData.value }} {{bodyMuscleMassData.units}}</span>
              <span v-else> N/A </span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="bodyMuscleMassData"><span style="font-weight: bold">{{ bodyMuscleMassData.previousValue }} {{ bodyMuscleMassData.units }} </span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}</span>
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }} {{$t('dashboard_new_evollu.measurement_types.body_mass_index_short')}}</h5>
              </div>
            </div>
            <span v-if="imcResultData" :style="{ color: imcResultData.resultColour }">
              {{imcResultData.resultName}}
            </span>
            <span v-else class="measurement-result-na">
              N/A
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }} {{$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short')}}</h5>
              </div>
            </div>
            <span v-if="fatResultData" :style="{ color: fatResultData.resultColour }">
              {{fatResultData.resultName}}
            </span>
            <span v-else class="measurement-result-na">
              N/A
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100 ">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.measurement_types.body_mass_index_short')})}} </h5>
              </div>
            </div>
            <div v-if="imcResultData && imcResultData.referenceValues.length > 0">
              <table>
                <tr v-for="elem in imcResultData.referenceValues">
                  <td>
                    {{ handleReferenceValuesCriterias(elem) }}
                  </td>
                  <td>
                    {{ elem.resultMatchingCriteria }}
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <span>N/A</span>
            </div>

          </div>
        </td>
        <td>
          <div class="measurement-card h-100 ">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.measurement_types.body_fat_percentage_short')})}} </h5>
              </div>
            </div>
            <div v-if="fatResultData && fatResultData.referenceValues.length > 0">
              <table>
                <tr v-for="elem in fatResultData.referenceValues">
                  <td>
                    {{ handleReferenceValuesCriterias(elem) }}
                  </td>
                  <td>
                    {{ elem.resultMatchingCriteria }}
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <span>N/A</span>
            </div>

          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ handleRecommendation }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bodyWeightData: null,
      bodyFatData: null,
      bodyWaterData: null,
      bodyMassIndexData: null,
      bodyMuscleMassData: null,
      imcResultData: null,
      fatResultData: null
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'BW') {
        this.bodyWeightData = elem
      } else if(elem.attributeCode === 'BMI') {
        this.bodyMassIndexData = elem
      }else if(elem.attributeCode === 'BF') {
        this.bodyFatData = elem
      }else if(elem.attributeCode === 'BWP') {
        this.bodyWaterData = elem
      }else if(elem.attributeCode === 'BMM') {
        this.bodyMuscleMassData = elem
      }
    })

    this.data.results.forEach(elem => {
      if(elem.measurementGroupChartId === 15) {
        this.imcResultData = elem
      } else if (elem.measurementGroupChartId === 16) {
        this.fatResultData = elem
      }
    })
    //console.log(this.data)
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  },
  computed: {
    handleRecommendation: function() {
      let recommendationStr = ''

      if(this.imcResultData && this.imcResultData.recommendations && this.imcResultData.recommendations.length) {
        this.imcResultData.recommendations.forEach(rec => {
          recommendationStr += rec+' '
        })
      }

      if(this.fatResultData && this.fatResultData.recommendations && this.fatResultData.recommendations.length) {
        recommendationStr += '\n'
        this.fatResultData.recommendations.forEach(rec => {
          recommendationStr += rec+' '
        })
      }


      return recommendationStr !== '' ? recommendationStr : "N/A"
    }
  }
}
</script>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}


table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
